import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.SignupConsente', {
    consentText:
        'By clicking "{buttonText}", you agree to our <terms>Terms and Conditions</terms> and <policy>Privacy Policy</policy>',
});
